export default __webpack_public_path__ + "static/media/ki.a1ebe299.jpg";